import React,  { Component }  from 'react'
import { Route, Redirect } from 'react-router-dom'
import Home from './views/home/Home'
import SubmissionMenu from './views/submission/submission-menu/SubmissionMenu'
import Management from './views/management/Management'
import ExperimentView from './views/management/experiments-view/ExperimentView'
import FilesView from './views/management/files-view/FilesView'
import QcMetrics from './views/management/qc-metrics/QcMetrics'
import SubmitExperiment from './views/submission/submit-experiments/SubmitExperiment'
import SubmitFiles from './views/submission/submit-files/SubmitFiles'
import SubmissionExperimentClose from './views/submission/submission-experiment-close/SubmissionExperimentClose'
import SelectExperiments from './views/submission/select-experiments/SelectExperiments'
import SelectGroup from './views/submission/select-group/SelectGroup'
import ExperimentSubmissionChoices from './views/submission/experiment-submission-choices/ExperimentSubmissionChoices'
import ExperimentTemplateSubmission from './views/submission/experiment-template-submission/ExperimentTemplateSubmission'
import SummaryInserted from './views/submission/components/SummaryInserted'
import ExperimentAnalysisStatus from './views/management/experiment-analysis-status/ExperimentAnalysisStatus'
import TaggedVariants from './views/management/tagged-variants/TaggedVariants'
import StaticsDataAccess from './views/management/statistics-data-access/StaticsDataAccess'
import DetailedStaticsDataAccess from './views/management/statistics-data-access/DetailedStaticsDataAccess'
import ActionPage from './views/management/experiments-view/ActionPage'
import ExperimentInfo from './views/management/experiment-info/ExperimentInfo'
import AsperaSummary from './views/admin/aspera/AsperaSummary'
import AsperaInfo from './views/admin/aspera/AsperaInfo'
import AsperaExperiments from './views/admin/aspera/AsperaExperiments'
import ExperimentSummary from './views/admin/experimentAnalysis/ExperimentSummary'
import ExperimentStatusInfo from './views/admin/experimentAnalysis/ExperimentStatusInfo'
import {ExperimentsNoFiles} from './views/admin/experimentsNoFiles/ExperimentsNoFiles'
import ExperimentsDates from './views/admin/experimentsDates/ExperimentsDates'
import ExperimentBatchEdition from './views/admin/experimentBatchEdition/ExperimentBatchEdition'
import FileStatus from './views/admin/fileStatus/FileStatus'

import {AdminMenu} from './views/admin/AdminMenu'
import Layout from './service/Layout'
import Login from "./service/Login";
import auth from './service/Auth';

import '@trendmicro/react-sidenav/dist/react-sidenav.css';

// OVERRIDE SIDENAV ELEMENTS
import "./sidenav-app/sidenav_custom.css";

import SideNavApp from "./sidenav-app/SideNav";
import YouDataManagement from "./views/your_datamanagement/YourDataManagement";
import Project from "./views/management/project/Project";

// The Main component renders one of the provided
// Routes (provided that one matches).

const config = window.config;

function AuthenticatedRoute({component: Component,enabled,  ...rest}) {
  return (
    <Route
      {...rest}
      render={
        (props) => (
              auth.user.authenticated===true || !enabled
              ? <Component {...props} {...rest} />
              : (
                  <Redirect
                      to={{
                           pathname: "/login/",
                           state: { from: props.location }
                      }}
                  />
                )
             )
      } />
  )
}

class App extends Component {

    constructor(props) {
        super(props);
        this.state = {
            keycloak: auth.user.keycloak,
            authenticated: auth.user.authenticated,
            auth:props.auth
        };
    }

    render() {
        return (
            <React.Fragment>
                <SideNavApp/>
                <div className={"main"}>
                    <Layout/>
                    <div className="content_custom">
                        <Route exact path="/" component={() => {

                            if(auth.getToken()!== undefined){
                                return <Redirect to={"/your_datamanagement"}/>
                            }
                            else{
                                return <Home/>
                            }

                        }}/>
                        <AuthenticatedRoute path="/your_datamanagement" component={YouDataManagement} enabled={config.security}/>
                        <Route exact path="/submission" component={SubmissionMenu}/>
                        <Route exact path="/management" component={Management}/>
                        <AuthenticatedRoute path='/experiments' component={ExperimentView} enabled={config.security}/>
                        <AuthenticatedRoute path='/files' component={FilesView} enabled={config.security}/>
                        <AuthenticatedRoute path='/qcmetrics' component={QcMetrics} enabled={config.security}/>
                        <AuthenticatedRoute path='/selectgroup' component={SelectGroup} enabled={config.security}/>
                        <AuthenticatedRoute path='/experimentsubmissionchoices' component={ExperimentSubmissionChoices} enabled={config.security}/>
                        <AuthenticatedRoute path='/experimenttemplatesubmission' component={ExperimentTemplateSubmission} enabled={config.security}/>
                        <AuthenticatedRoute path='/submitexperiments' component={SubmitExperiment} enabled={config.security}/>
                        <AuthenticatedRoute path='/selectexperiments' component={SelectExperiments} enabled={config.security}/>
                        <AuthenticatedRoute path='/submitfiles' component={SubmitFiles} enabled={config.security}/>
                        <AuthenticatedRoute path='/experimentsubmitted' component={SummaryInserted} enabled={config.security}/>
                        <AuthenticatedRoute path='/filesubmitted' component={SummaryInserted} enabled={config.security}/>
                        <AuthenticatedRoute path='/submissionexperimentclose' component={SubmissionExperimentClose} enabled={config.security}/>
                        <AuthenticatedRoute path='/experimentanalysisstatus' component={ExperimentAnalysisStatus} enabled={config.security}/>
                        <AuthenticatedRoute path='/taggedvariants' component={TaggedVariants} enabled={config.security}/>
                        <AuthenticatedRoute path='/staticdataaccess' component={StaticsDataAccess} enabled={config.security}/>
                        <AuthenticatedRoute path='/detailedStaticsDataAccess/:experiment_id' component={DetailedStaticsDataAccess} enabled={config.security}/>                            
                        <AuthenticatedRoute path='/actionpage' component={ActionPage} enabled={config.security}/>
                        <AuthenticatedRoute path='/experimentinfo/:experiment_id' component={ExperimentInfo} enabled={config.security}/>
                        <AuthenticatedRoute path='/project/:project_name' component={Project} enabled={config.security}/>
                        <AuthenticatedRoute path='/admin/aspera' component={AsperaSummary} enabled={config.security}/>
                        <AuthenticatedRoute path='/admin/asperainfo' component={AsperaInfo} enabled={config.security}/>
                        <AuthenticatedRoute path='/admin/asperaexperimentsinfo' component={AsperaExperiments} enabled={config.security}/>
                        <AuthenticatedRoute path='/admin/experimentprogress' component={ExperimentSummary} enabled={config.security}/>
                        <AuthenticatedRoute path='/admin/experimentstatusinfo' component={ExperimentStatusInfo} enabled={config.security}/>
                        <AuthenticatedRoute path='/admin/experimentsnofiles' component={ExperimentsNoFiles} enabled={config.security}/>
                        <AuthenticatedRoute path='/admin/experimentshistoricreport' component={ExperimentsDates} enabled={config.security}/>
                        <AuthenticatedRoute path='/admin/filesstatus' component={FileStatus} enabled={config.security}/>
                        <AuthenticatedRoute path='/admin/experimentbatchedition' component={ExperimentBatchEdition} enabled={config.security}/>
                        <AuthenticatedRoute path='/admin' component={AdminMenu} enabled={config.security}/>
                        <Route path="/login" render={(props) => <Login {...props} auth={this.state.auth}/> } />
                        <Route path='/phenostore' component={() => {
                            window.location.href = window.location.origin + '/phenostore';
                            return null;
                        }}/>
                        <Route path='/phenobrowse' component={() => {
                            window.location.href = window.location.origin + '/phenostore/#/browse/patient';
                            return null;
                        }}/>
                        <Route path='/nextgpap' component={() => {
                            window.location.href = window.location.origin + '/nextgpap/';
                            return null;
                        }}/>
                        <Route path='/cohortapp' component={() => {
                            window.location.href= window.location.origin + '/cohortapp';
                            return null;

                        }}/>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}


export default App;
